/**
 * Options used to classify a missing or unavailable auth token.
 */
export interface AuthTokenUnavailableErrorOptions {
  /** Underlying error raised while fetching the token. */
  cause?: unknown;
  /** Optional auth-provider error code. */
  code?: string;
  /** Whether the token request can be retried. */
  retryable?: boolean;
}

/**
 * Raised when API setup cannot resolve a usable auth token.
 */
export class AuthTokenUnavailableError extends Error {
  /** Underlying error raised while fetching the token. */
  cause?: unknown;
  /** Optional auth-provider error code. */
  code?: string;
  /** Whether the token request can be retried. */
  retryable: boolean;

  constructor(message: string, options?: AuthTokenUnavailableErrorOptions) {
    super(message);
    this.name = 'AuthTokenUnavailableError';
    this.cause = options?.cause;
    this.code = options?.code;
    this.retryable = options?.retryable ?? false;
  }
}
